import { useEffect } from 'react';
import { useRouter } from './use-router';
import { ERoutesPublic, ERoutesType, routes } from 'types/routes';
import useAuth from './use-auth';

function useRequireAuth(
    redirectUrl: string = routes[ERoutesType.Public][ERoutesPublic.SignIn][0],
) {
    const isLoggedIn = useAuth();
    const router = useRouter();

    useEffect(() => {
        if (!isLoggedIn) {
            router.push(redirectUrl);
        }
    }, [isLoggedIn, redirectUrl, router]);
}

export default useRequireAuth;
